import { NON_INTERNATIONAL_COUNTRIES_ISO } from "@constants/country";
import { POINTS_CURRENCY_CODE } from "@constants/store";

export const formatPrice = (number, { prefix = "", suffix = "" } = {}) => {
  const displayPrice = new Intl.NumberFormat().format(number);
  return `${prefix} ${displayPrice} ${suffix}`.trim();
};

export const computeCurrencyAmount = (
  points,
  conversionRate,
  pointsPerUsd,
  stadiumWalletBalanceInUsd
) => {
  const priceInUsd = points / pointsPerUsd;
  const computedAmount = priceInUsd * conversionRate;
  const computedstadiumWalletBalance = stadiumWalletBalanceInUsd * conversionRate;
  const youPayAmount =
    computedAmount > computedstadiumWalletBalance
      ? computedAmount - computedstadiumWalletBalance
      : 0;
  return parseFloat(youPayAmount.toFixed(2));
};

export const getCurrencyCode = (currencies, currencyId) =>
  currencies.find((elmt) => elmt.id === currencyId)?.code?.toLowerCase();

const isInternational = (country) => !NON_INTERNATIONAL_COUNTRIES_ISO.includes(country.iso);

export const getCountriesWithInternationalData = (configData) => {
  const { countries } = configData;

  const updatedCountries = countries?.map((country) => ({
    ...country,
    international: isInternational(country),
  }));

  return { ...configData, countries: updatedCountries };
};

export const isCurrencyPoints = (currencyCode) => currencyCode === POINTS_CURRENCY_CODE;
